import { Attribution, AttributionParam } from '../constants/AttributionParam';

export const FIRST_TOUCH_COOKIE_NAME = 'chromatic_internal_first_touch';
export const LAST_TOUCH_COOKIE_NAME = 'chromatic_internal_last_touch';

// UTM params are mapped the properties of the campaign object in Segment.
const UTM_PARAM_MAPPINGS = {
  session_id: 'session_id',
  referrer: 'referrer',
  landing_page: 'landing_page',
  utm_campaign: 'name',
  utm_source: 'source',
  utm_medium: 'medium',
  utm_content: 'content',
  utm_term: 'term',
  fbclid: 'fbclid',
  ad_id: 'ad_id',
  gclid: 'gclid',
  gc_id: 'gclid',
} as const;

export const mapAttributionToSegmentParams = (attribution: Attribution) =>
  Object.fromEntries(
    Object.entries(attribution).map(([key, value]) => {
      const segmentKey = UTM_PARAM_MAPPINGS[key as keyof typeof UTM_PARAM_MAPPINGS];
      return [segmentKey, value];
    })
  ) as Record<(typeof UTM_PARAM_MAPPINGS)[keyof typeof UTM_PARAM_MAPPINGS], string>;

export const mapFirstTouchToTraits = (firstTouch: Attribution) =>
  Object.fromEntries(
    Object.entries(firstTouch).map(([key, value]) => [`first_touch_${key}`, value])
  );
